import { render, staticRenderFns } from "./ContractProjectList.vue?vue&type=template&id=f0ba7e06&scoped=true&"
import script from "./ContractProjectList.vue?vue&type=script&lang=js&"
export * from "./ContractProjectList.vue?vue&type=script&lang=js&"
import style0 from "./ContractProjectList.vue?vue&type=style&index=0&id=f0ba7e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ba7e06",
  null
  
)

export default component.exports